module.exports = __webpack_public_path__ + "static/img/8.5a82f14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shop/product/8.jpg
// module id = dkbd
// module chunks = 1